export default class FilaStatusEnum {
    static Pendente = 1
    static Ativa = 2
    static Inativa = 3
}
